<ng-container *ngIf="paginationButtonsArray$ | async as visiblePages">
  <nav *ngIf="pageCount$ | async" aria-label="Pagination" i18n-aria-label>
    <ul class="pages">
      <li *ngIf="showSkipButtons$ | async">
        <button
          type="button"
          class="page-indicator skip"
          aria-label="First page"
          i18n-aria-label
          [disabled]="disableBackButtons$ | async"
          (click)="skipToBeginning()">
          <img src="assets/icons/grey/Double Chevron Left.svg" alt="" />
        </button>
      </li>
      <li>
        <button
          type="button"
          class="page-indicator nav"
          aria-label="Previous page"
          i18n-aria-label
          [disabled]="disableBackButtons$ | async"
          (click)="previousPageClicked()">
          <img src="assets/icons/grey/Chevron Left.svg" alt="" />
        </button>
      </li>
      <li class="paginator-button pt-2" *ngIf="showLeftEllipsis$ | async" aria-hidden="true">
        <img class="ellipsis" src="assets/icons/dark/Ellipses Horizontal.svg" alt="" />
      </li>
      <li *ngFor="let pageButton of visiblePages; trackBy: trackByPage">
        <button
          type="button"
          class="page-indicator"
          [attr.aria-label]="pageButton.ariaLabel"
          [class.active]="pageButton.isCurrent"
          [attr.aria-current]="pageButton.ariaCurrent"
          (click)="pageClicked(pageButton.page)">
          <span class="page-number">{{ pageButton.page }}</span>
        </button>
      </li>
      <li class="paginator-button pt-2" *ngIf="showRightEllipsis$ | async" aria-hidden="true">
        <img class="ellipsis" src="assets/icons/dark/Ellipses Horizontal.svg" alt="" />
      </li>
      <li>
        <button
          type="button"
          class="page-indicator nav"
          aria-label="Next page"
          i18n-aria-label
          [disabled]="disableForwardButtons$ | async"
          (click)="nextPageClicked()">
          <img src="assets/icons/grey/Chevron Right.svg" alt="" />
        </button>
      </li>
      <li *ngIf="showSkipButtons$ | async">
        <button
          type="button"
          class="page-indicator skip"
          aria-label="Last page"
          i18n-aria-label
          [disabled]="disableForwardButtons$ | async"
          (click)="skipToEnd()">
          <img src="assets/icons/grey/Double Chevron Right.svg" alt="" />
        </button>
      </li>
    </ul>
  </nav>
</ng-container>
